import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';

@Injectable()
export class AuthService
{
    constructor(
        private router: Router,
        private toastr: ToastrService
    ){}

    public setToken(token, 
         user,
         userID,
         EMP_BI_ID,
         perfilID,
         perfil,
         paramter
         
         ) {
        const now = new Date().getTime();
        localStorage.setItem('setupTime', now.toString());
        localStorage.setItem('token', token);
        localStorage.setItem('user', user);
        localStorage.setItem('userID', userID);
        localStorage.setItem('EMP_BI_ID', EMP_BI_ID);
        localStorage.setItem('perfilID', perfilID);
        localStorage.setItem('perfil', perfil);
        localStorage.setItem('parameters', JSON.stringify(paramter) );

     
/*

*/
    }
    public removeToken() {
        localStorage.clear();
    }
    public getToken(){
        return localStorage.getItem('token');
    }
    public getUser(){
        return localStorage.getItem('user');
    }
    public getUserID(){
        return localStorage.getItem('userID');
    }

    public getEmployeeID(){
        return localStorage.getItem('EMP_BI_ID');
    }
    public getPerfilID(){
        return localStorage.getItem('perfilID');
    }
   
    public getPerfil(){
        return localStorage.getItem('perfil');
    }
   
    public getParameters(){
        return  JSON.parse(localStorage.getItem('parameters'));
    }

    public cerrarSesion(param: string = '') {
        localStorage.clear();
        this.router.navigate(['/login']);
        if(param == 'inactividad'){
          this.toastr.success("Cierre de sesión por inactividad.", "Success");
        }else{
          this.toastr.success("Cierre de sesión satisfatorio.", "Success");
        }
    }
}